module.exports = __webpack_public_path__ + "static/kid-bg-86b4f6b907e2668ff475f6394050443b.jpg";